import { useState, useEffect } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import Sidebar from './Sidebar/Sidebar';
import Header from './Headers/Header';

const DashboardLayout = ({ children, onLogout }) => {
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [isMobile, setIsMobile] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
      if (window.innerWidth < 768) {
        setSidebarOpen(false);
      } else {
        setSidebarOpen(true);
      }
    };

    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  const getActiveMenu = () => {
    // Get the current path relative to /home
    const path = location.pathname.replace('/', '') || '/';
    
    if (path === 'home' || path === '') return 'Home';
    if (path === 'attendance') return 'Attendance View';
    // if (path === 'Elective') return 'Elective Subject';
    if (path === 'Curriculum') return 'Curriculum';
    if (path === 'exam-fees') return 'Exam Fees';
    // if (path === 'exam-timetable') return 'Exam TimeTable';
    // if (path === 'hall-ticket') return 'Hall Ticket';
    // if (path === 'exam-result') return 'Exam Result';
    // if (path === 'profile') return 'Student Profile';
    // if (path === 'feedback') return 'Feed Back';
    return 'Home';
  };

  const handleMenuChange = (menu) => {
    let path = '/';
    switch(menu) {
      case 'Home': path += 'home'; break;
      case 'Attendance View': path += 'attendance'; break;
      // case 'Elective Subject': path += 'Elective'; break;
      case 'Curriculum': path += 'Curriculum'; break;
      case 'Exam Fees': path += 'exam-fees'; break;
      // case 'Exam TimeTable': path += 'exam-timetable'; break;
      // case 'Hall Ticket': path += 'hall-ticket'; break;
      // case 'Exam Result': path += 'exam-result'; break;
      // case 'Student Profile': path += 'profile'; break;
      // case 'Feed Back': path += 'feedback'; break;
      default: path += 'home';
    }
    return path;
  };

  const activeMenu = getActiveMenu();

  return (
    <div className="flex h-screen bg-gray-50">
      {isMobile && sidebarOpen && (
        <div 
          className="fixed inset-0 bg-black bg-opacity-50 z-20"
          onClick={toggleSidebar}
        />
      )}
      
      <Sidebar 
        sidebarOpen={sidebarOpen}
        activeMenu={activeMenu}
        setActiveMenu={(menu) => {
          const path = handleMenuChange(menu);
          navigate(path);
        }}
        toggleSidebar={toggleSidebar}
        isMobile={isMobile}
      />
      
      <div className="flex-1 flex flex-col overflow-hidden">
        <Header 
          activeMenu={activeMenu} 
          toggleSidebar={toggleSidebar}
          isMobile={isMobile}
          onLogout={onLogout}
        />
        <div className="flex-1 overflow-hidden pb-3">
          {children || <Outlet />}
        </div>

        {/* Footer */}
        <footer
          className="
            fixed
            bottom-0
            left-0
            right-0
            z-50
            sm:px-5
            bg-black
            backdrop-blur-md
            border-t
            border-white/10
          "
        >
          <div
            className="
              max-w-7xl
              mx-auto
              flex
              flex-col
              sm:flex-row
              items-center
              justify-between
              gap-2
              sm:gap-4
            "
          >
            <div></div>
            <p
              className="
                text-white
                text-[10px]
                xs:text-xs
                sm:text-sm
                font-medium
                text-center
                leading-tight
                order-2
                sm:order-1
              "
            >
              © 2026 Directorate of Technical Education (DOTE).
              <span className="hidden sm:inline"> </span>
              All Rights Reserved.
            </p>

            {/* Powered By */}
            <div
              className="
                flex
                flex-row
                sm:flex-col
                items-center
                justify-center
                gap-1
                sm:gap-0
                order-1
                sm:order-2
              "
            >
              <span
                className="
                  text-white/70
                  text-[9px]
                  sm:text-[10px]
                  font-medium
                  leading-none
                "
              >
                Powered by
              </span>

              <span
                className="
                  text-white
                  text-[10px]
                  sm:text-xs
                  font-bold
                  leading-none
                  whitespace-nowrap
                "
              >
                PSG Software Technologies
              </span>
            </div>
          </div>
        </footer>
      </div>
    </div>
  );
};

export default DashboardLayout;